import type Component from "../Component.ts";

const PotentialPasswordParameters = [
    "Password",
    "Api Key",
    "Api Key Value",
    "SSLClientCertPassword",
    "API Key",
    "API Token",
    "Secret Key",
    "Access Key",
    "Bearer Token",
    "Shared Link Password",
    "Private App Token",
    "Certificate",
    "Private Key",
    "Key",
    "Intercom Access Token",
    "API Password",
    "Security Token",
    "Key Value",
    "Source Password",
    "Target Password",
    "Sandbox Access Token",
    "Sender Password",
    "SMTP Password",
    "Authentication Token",
    "App ID"
]

export function containsStringPassword(component: Component): boolean {
    try {
        // Loop through the parameters, find ones with one of the names in the potential array, check it's only got 1 value/element, check if the type is STRING
        return Object.values(component.parameters).some(parameter => {
            if(!PotentialPasswordParameters.includes(parameter.name)) return false
            const elements = Object.values(parameter.elements)
            if(elements.length !== 1 || elements[0].slot !== 1) return false // Can't have multiple elements
            const element = elements[0]
            if(!element) return false // Safety check? Not sure how we can hit this but it looks like we have
            const values = Object.values(element.values)
            if(values.length !== 1 || values[0].slot !== 1) return false // Can't have multiple values

            //A good value will have "PASSWORD" as the type, a bad one will have "STRING"
            return values[0].type === "STRING"
        })
    } catch(e) {
        console.error("Error scanning for string passwords", e)
        return false
    }
}